var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Prop, ModelSync, Watch } from 'vue-property-decorator';
import { BOverlay, BRow, BCol } from 'bootstrap-vue';
import axios from 'axios';
import FrameDesignOption from 'components/picture-frames/Value/FrameDesignOption.vue';
let FrameDesignSelector = class FrameDesignSelector extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.frameSizes = [];
        this.noMountPrice = '0.00';
    }
    get isItemSizeValidFrame() {
        return this.itemSize.width >= 100 && this.itemSize.length >= 100;
    }
    getFrameSizes() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            let promises = [];
            if (this.isItemSizeValidFrame) {
                promises.push(axios
                    .get('/api/valueFrames/noFramePrice', {
                    params: {
                        groupID: this.groupId,
                        itemWidth: this.itemSize.width,
                        itemLength: this.itemSize.length,
                        lengthSku: this.lengthSku,
                    }
                })
                    .then(({ data }) => this.noMountPrice = data.price));
            }
            promises.push(axios
                .get('/api/valueFrames/frameSizes', {
                params: {
                    groupID: this.groupId,
                    itemWidth: this.itemSize.width,
                    itemLength: this.itemSize.length,
                    lengthSku: this.lengthSku,
                    mountSku: this.mount.stock_lookup_sku
                }
            })
                .then(({ data }) => this.frameSizes = data.map(size => ({
                type: size.type,
                name: size.name,
                width: size.width_mm,
                length: size.height_mm,
                price: size.price
            }))));
            yield Promise.all(promises);
            if (this.isItemSizeValidFrame) {
                // Select the no mount option by default
                this.selectSize(this.itemSize);
            }
            else {
                this.selectSize(this.frameSizes[0]);
            }
            this.loading = false;
        });
    }
    selectSize(size) {
        this.$emit('change', size);
    }
    mounted() {
        this.getFrameSizes();
    }
};
__decorate([
    ModelSync('frameSize', 'change', { type: Object })
], FrameDesignSelector.prototype, "selectedFrameSize", void 0);
__decorate([
    Prop(Number)
], FrameDesignSelector.prototype, "groupId", void 0);
__decorate([
    Prop(Object)
], FrameDesignSelector.prototype, "itemSize", void 0);
__decorate([
    Prop(String)
], FrameDesignSelector.prototype, "lengthSku", void 0);
__decorate([
    Prop(Object)
], FrameDesignSelector.prototype, "mount", void 0);
__decorate([
    Watch('itemSize', { deep: true }),
    Watch('mountSku')
], FrameDesignSelector.prototype, "getFrameSizes", null);
FrameDesignSelector = __decorate([
    Component({
        components: {
            BOverlay, BRow, BCol,
            FrameDesignOption
        }
    })
], FrameDesignSelector);
export default FrameDesignSelector;
